import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { OverlayModule } from '@angular/cdk/overlay';
import { A11yModule } from '@angular/cdk/a11y';
import { BidiModule } from '@angular/cdk/bidi';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PlatformModule } from '@angular/cdk/platform';
import { CopyOnHoverDirective } from './copy-on-hover.directive';

@NgModule({
  declarations: [CopyOnHoverDirective],
  imports: [
    CommonModule,
    MatTooltipModule,
    ClipboardModule,
    OverlayModule,
    A11yModule,
    BidiModule,
    ScrollingModule,
    PlatformModule,
  ],
  exports: [CopyOnHoverDirective],
})
export class CopyOnHoverModule {}
